import {Component, EventEmitter, Input, OnInit} from '@angular/core';
import {AbstractControl, FormControl, FormGroup} from "@angular/forms";
import {CatalogosService} from "../../../../services/catalogos.service";
import { BehaviorSubject, Observable, Subject, combineLatest, forkJoin, of } from 'rxjs';
import { EvkOption } from '@evomatik/evk-common';
import { filter, map, startWith } from 'rxjs/operators';

@Component({
    selector: 'lib-datos-localizacion',
    templateUrl: './datos-localizacion.component.html',
    styleUrls: ['./datos-localizacion.component.css']
})
export class DatosLocalizacionComponent implements OnInit {
    @Input()
    form: FormGroup;
    municipioFilteredOptions$: Observable<EvkOption[]>;
    localidadFilteredOptions$: Observable<EvkOption[]>;
    coloniaFilteredOptions$: Observable<EvkOption[]>;
    municipioOptions: EvkOption[] = [];
    localidadOptions: EvkOption[] = [];
    coloniaOptions: EvkOption[] = [];
    catalogosCargados: EventEmitter<boolean> = new EventEmitter();

    constructor(
        public catalogoService: CatalogosService
    ) {
    }

    ngOnInit(): void {
        this.cargaCatalogos();
        this.eventHandlerEventInit();
    }

    cargaCatalogos() {
        const requests = [];
        requests.push(this.catalogoService.getMunicipiosInegi("60fef117a65f8a241f8d20f7"));
        requests.push(this.catalogoService.getLocalidadesInegi(this.form.controls.a4MunicipioLocalizacion?.value?.value));
        requests.push(this.catalogoService.getColoniasInegi(this.form.controls.a4LocalidadLocalizacion?.value?.value));
        forkJoin(requests).subscribe((
            [municipio, localidad, colonia]:
                [EvkOption[], EvkOption[], EvkOption[]]
        ) => {
            this.municipioOptions = municipio;
            this.localidadOptions = localidad;
            this.coloniaOptions = colonia;
            this.catalogosCargados.emit(true);
        });
    }

    changeMunicipio($event: any) {
        if ($event.option.value && $event.option.value !== '' && $event.option.value.value) {
            this.form.controls.a4LocalidadLocalizacion.setValue(undefined);
            this.form.controls.a4ColoniaLocalizacion.setValue(undefined);
            const requests = [];
            requests.push(this.catalogoService.getLocalidadesInegi($event.option.value.value));
            forkJoin(requests).subscribe((
                [localidad]:
                    [EvkOption[]]
            ) => {
                this.localidadOptions = localidad;
                this.coloniaOptions = [];
                this.catalogosCargados.emit(true);
            });
        }
    }

    changeLocalidad($event: any) {
        if ($event.option.value && $event.option.value !== '' && $event.option.value.value) {
            console.log($event.option.value.value);
            this.form.controls.a4ColoniaLocalizacion.setValue(undefined);
            const requests = [];
            requests.push(this.catalogoService.getColoniasInegi($event.option.value.value));
            forkJoin(requests).subscribe((
                [colonia]:
                    [EvkOption[]]
            ) => {
                this.coloniaOptions = colonia;
                this.catalogosCargados.emit(true);
            });
        }
    }

    eventHandlerEventInit() {
        this.catalogosCargados.subscribe((res) => {
            if (res) {
                this.municipioFilteredOptions$ = this.filterOptions(this.form.controls.a4MunicipioLocalizacion, of(this.municipioOptions));
                this.localidadFilteredOptions$ = this.filterOptions(this.form.controls.a4LocalidadLocalizacion, of(this.localidadOptions));
                this.coloniaFilteredOptions$ = this.filterOptions(this.form.controls.a4ColoniaLocalizacion, of(this.coloniaOptions));
            }
        });
    }

    removeAccents = (str) => {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    _filter(label: string, options: EvkOption[]): EvkOption[] {
        const filterValue = this.removeAccents(label.toLowerCase());
        return options.filter(
            option =>
                this.removeAccents(option.label.toLowerCase()).indexOf(filterValue) !== -1);
    }

    filterOptions = (formControl: FormControl | AbstractControl, opciones$: Observable<EvkOption[]>, valueChanges?: Observable<any> | Subject<any> | BehaviorSubject<any>) => {
        const valueChanges$ = valueChanges ? valueChanges : formControl.valueChanges;
        return combineLatest(
            [
                valueChanges$.pipe(startWith('')),
                opciones$
            ]
        ).pipe(
            filter(([value, _]) => typeof value === 'string'
            ),
            map(([name, opciones]: any) => name ? this._filter(name, opciones) : opciones.slice())
        );

    }

    displayFn = (option) => (option && option.label) ? option.label : '';
}
